import React from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  TextInputProps,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface FloatingLabelInputProps extends Omit<TextInputProps, 'style'> {
  label: string;
  value: string;
  error?: string;
  containerStyle?: object;
}

/**
 * Reusable input component with floating label
 * Used in credit card and ACH forms
 */
export const FloatingLabelInput: React.FC<FloatingLabelInputProps> = ({
  label,
  value,
  error,
  containerStyle,
  ...textInputProps
}) => {
  const hasValue = value.length > 0;

  return (
    <View style={[styles.inputWrapper, containerStyle]}>
      <View style={styles.inputWithLabel}>
        {hasValue && (
          <Text style={styles.inputLabel}>{label}</Text>
        )}
        <TextInput
          style={[
            styles.input,
            hasValue && styles.inputWithValue,
            error && styles.inputError,
          ]}
          value={value}
          placeholder={label}
          placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
          autoComplete="off"
          {...textInputProps}
        />
      </View>
      {error && (
        <Text style={styles.errorText}>{error}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  inputWrapper: {
    marginBottom: 4,
  },
  inputWithLabel: {
    position: 'relative',
  },
  inputLabel: {
    position: 'absolute',
    top: 4,
    left: 16,
    fontSize: 10,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 12.5,
    zIndex: 1,
  },
  input: {
    height: 40,
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    paddingHorizontal: 16,
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
  },
  inputWithValue: {
    paddingTop: 14,
    paddingBottom: 4,
  },
  inputError: {
    borderColor: MARKETPLACE_COLORS.accentRed,
  },
  errorText: {
    fontSize: 12,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.accentRed,
    marginTop: 4,
  },
});

export default FloatingLabelInput;
